// ActionTypes for generalSettings

//Vat Period Action Types List, Details, Create, Update, Delete

export const GET_VAT_PERIOD_LIST = "GET_VAT_PERIOD_LIST";
export const GET_VAT_PERIOD_LIST_SUCCESS = "GET_VAT_PERIOD_LIST_SUCCESS";
export const GET_VAT_PERIOD_LIST_FAILURE = "GET_VAT_PERIOD_LIST_FAILURE";

export const GET_VAT_PERIOD_DETAILS = "GET_VAT_PERIOD_DETAILS";
export const GET_VAT_PERIOD_DETAILS_SUCCESS = "GET_VAT_PERIOD_DETAILS_SUCCESS";
export const GET_VAT_PERIOD_DETAILS_FAILURE = "GET_VAT_PERIOD_DETAILS_FAILURE";

export const ADD_VAT_PERIOD = "ADD_VAT_PERIOD";
export const ADD_VAT_PERIOD_SUCCESS = "ADD_VAT_PERIOD_SUCCESS";
export const ADD_VAT_PERIOD_FAILURE = "ADD_VAT_PERIOD_FAILURE";

export const UPDATE_VAT_PERIOD = "UPDATE_VAT_PERIOD";
export const UPDATE_VAT_PERIOD_SUCCESS = "UPDATE_VAT_PERIOD_SUCCESS";
export const UPDATE_VAT_PERIOD_FAILURE = "UPDATE_VAT_PERIOD_FAILURE";

export const DELETE_VAT_PERIOD = "DELETE_VAT_PERIOD";
export const DELETE_VAT_PERIOD_SUCCESS = "DELETE_VAT_PERIOD_SUCCESS";
export const DELETE_VAT_PERIOD_FAILURE = "DELETE_VAT_PERIOD_FAILURE";

//Renewal Frequencies Action Types List, Details, Create, Update, Delete

export const GET_RENEWAL_FREQUENCIES_LIST = "GET_RENEWAL_FREQUENCIES_LIST";
export const GET_RENEWAL_FREQUENCIES_LIST_SUCCESS =
  "GET_RENEWAL_FREQUENCIES_LIST_SUCCESS";
export const GET_RENEWAL_FREQUENCIES_LIST_FAILURE =
  "GET_RENEWAL_FREQUENCIES_LIST_FAILURE";

export const GET_RENEWAL_FREQUENCIES_DETAILS =
  "GET_RENEWAL_FREQUENCIES_DETAILS";
export const GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS =
  "GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS";
export const GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE =
  "GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE";

export const ADD_RENEWAL_FREQUENCIES = "ADD_RENEWAL_FREQUENCIES";
export const ADD_RENEWAL_FREQUENCIES_SUCCESS =
  "ADD_RENEWAL_FREQUENCIES_SUCCESS";
export const ADD_RENEWAL_FREQUENCIES_FAILURE =
  "ADD_RENEWAL_FREQUENCIES_FAILURE";

export const UPDATE_RENEWAL_FREQUENCIES = "UPDATE_RENEWAL_FREQUENCIES";
export const UPDATE_RENEWAL_FREQUENCIES_SUCCESS =
  "UPDATE_RENEWAL_FREQUENCIES_SUCCESS";
export const UPDATE_RENEWAL_FREQUENCIES_FAILURE =
  "UPDATE_RENEWAL_FREQUENCIES_FAILURE";

export const DELETE_RENEWAL_FREQUENCIES = "DELETE_RENEWAL_FREQUENCIES";
export const DELETE_RENEWAL_FREQUENCIES_SUCCESS =
  "DELETE_RENEWAL_FREQUENCIES_SUCCESS";
export const DELETE_RENEWAL_FREQUENCIES_FAILURE =
  "DELETE_RENEWAL_FREQUENCIES_FAILURE";

// Unit Frequencies Action Types List, Details, Create, Update, Delete

export const GET_UNIT_FREQUENCIES_LIST = "GET_UNIT_FREQUENCIES_LIST";
export const GET_UNIT_FREQUENCIES_LIST_SUCCESS =
  "GET_UNIT_FREQUENCIES_LIST_SUCCESS";
export const GET_UNIT_FREQUENCIES_LIST_FAILURE =
  "GET_UNIT_FREQUENCIES_LIST_FAILURE";

export const GET_UNIT_FREQUENCIES_DETAILS = "GET_UNIT_FREQUENCIES_DETAILS";
export const GET_UNIT_FREQUENCIES_DETAILS_SUCCESS =
  "GET_UNIT_FREQUENCIES_DETAILS_SUCCESS";
export const GET_UNIT_FREQUENCIES_DETAILS_FAILURE =
  "GET_UNIT_FREQUENCIES_DETAILS_FAILURE";

export const ADD_UNIT_FREQUENCIES = "ADD_UNIT_FREQUENCIES";
export const ADD_UNIT_FREQUENCIES_SUCCESS = "ADD_UNIT_FREQUENCIES_SUCCESS";
export const ADD_UNIT_FREQUENCIES_FAILURE = "ADD_UNIT_FREQUENCIES_FAILURE";

export const UPDATE_UNIT_FREQUENCIES = "UPDATE_UNIT_FREQUENCIES";
export const UPDATE_UNIT_FREQUENCIES_SUCCESS =
  "UPDATE_UNIT_FREQUENCIES_SUCCESS";
export const UPDATE_UNIT_FREQUENCIES_FAILURE =
  "UPDATE_UNIT_FREQUENCIES_FAILURE";

export const DELETE_UNIT_FREQUENCIES = "DELETE_UNIT_FREQUENCIES";
export const DELETE_UNIT_FREQUENCIES_SUCCESS =
  "DELETE_UNIT_FREQUENCIES_SUCCESS";
export const DELETE_UNIT_FREQUENCIES_FAILURE =
  "DELETE_UNIT_FREQUENCIES_FAILURE";

//Master Time Frame  Action Types List, Details, Create, Update, Delete

export const GET_MASTER_TIME_FRAME_LIST = "GET_MASTER_TIME_FRAME_LIST";
export const GET_MASTER_TIME_FRAME_LIST_SUCCESS =
  "GET_MASTER_TIME_FRAME_LIST_SUCCESS";
export const GET_MASTER_TIME_FRAME_LIST_FAILURE =
  "GET_MASTER_TIME_FRAME_LIST_FAILURE";

export const GET_MASTER_TIME_FRAME_DETAILS = "GET_MASTER_TIME_FRAME_DETAILS";
export const GET_MASTER_TIME_FRAME_DETAILS_SUCCESS =
  "GET_MASTER_TIME_FRAME_DETAILS_SUCCESS";
export const GET_MASTER_TIME_FRAME_DETAILS_FAILURE =
  "GET_MASTER_TIME_FRAME_DETAILS_FAILURE";

export const ADD_MASTER_TIME_FRAME = "ADD_MASTER_TIME_FRAME";
export const ADD_MASTER_TIME_FRAME_SUCCESS = "ADD_MASTER_TIME_FRAME_SUCCESS";
export const ADD_MASTER_TIME_FRAME_FAILURE = "ADD_MASTER_TIME_FRAME_FAILURE";

export const UPDATE_MASTER_TIME_FRAME = "UPDATE_MASTER_TIME_FRAME";
export const UPDATE_MASTER_TIME_FRAME_SUCCESS =
  "UPDATE_MASTER_TIME_FRAME_SUCCESS";
export const UPDATE_MASTER_TIME_FRAME_FAILURE =
  "UPDATE_MASTER_TIME_FRAME_FAILURE";

export const DELETE_MASTER_TIME_FRAME = "DELETE_MASTER_TIME_FRAME";
export const DELETE_MASTER_TIME_FRAME_SUCCESS =
  "DELETE_MASTER_TIME_FRAME_SUCCESS";
export const DELETE_MASTER_TIME_FRAME_FAILURE =
  "DELETE_MASTER_TIME_FRAME_FAILURE";

// Local Settings Master config List

export const GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST";
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS";
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE";

// Company Config Items (front-end editable) List
export const GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST =
  "GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST";
export const GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS =
  "GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS";
export const GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE =
  "GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE";

// Local Settings Master config Update toggle

export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE";
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS";
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE";

// Local Settings Master config user list

export const GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST";
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS";
export const GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE =
  "GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE";

// Local Settings Master config user update

export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER";
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS";
export const UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE =
  "UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE";
